import { Model } from '@vuex-orm/core'

export default class MZUser extends Model {
  static entity = 'mzusers'
  static primaryKey = 'id'

  static fields () {
    return {
      id: this.string(''),
      first_name: this.string(''),
      last_name: this.string(''),
      merchant_identifier: this.string(''),
      email: this.string(''),
      username: this.string(''),
      metadata: this.string(''),
      mobile_phone: this.string(''),
      marcom_opt_in: this.boolean(0)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/MZUser.js